export async function wait(millis = 0) {
  return new Promise((resolve) => setTimeout(resolve, millis));
}
